type Status = 'connected' | 'disconnected';
type Listener = (status: Status) => void;

class ConnectionStatusService {
  private status: Status = 'connected';
  private listeners: Set<Listener> = new Set();

  getStatus(): Status {
    return this.status;
  }

  setStatus(newStatus: Status): void {
    if (this.status !== newStatus) {
      const previousStatus = this.status;
      this.status = newStatus;
      console.log(`Connection Status Changed: ${previousStatus} -> ${this.status}`);
      
      try {
        this.emit(this.status);
      } catch (error) {
        console.error('Error emitting connection status change:', error);
        // Don't re-throw to prevent webpack overlay errors
      }
    }
  }

  on(listener: Listener): void {
    this.listeners.add(listener);
  }

  off(listener: Listener): void {
    this.listeners.delete(listener);
  }

  private emit(status: Status): void {
    this.listeners.forEach(listener => {
      try {
        listener(status);
      } catch (error) {
        console.error("Error in connection status listener:", error);
      }
    });
  }
}

// Export a singleton instance
const connectionStatusService = new ConnectionStatusService();
export default connectionStatusService;
